// components/UI/NotificationBanner.js
import React, { useState, useEffect } from 'react';
import { Bell, X } from 'lucide-react';
import './NotificationBanner.css';

const NotificationBanner = () => {
  const [showBanner, setShowBanner] = useState(false);
  const [permissionStatus, setPermissionStatus] = useState('default');

  useEffect(() => {
    if ('Notification' in window) {
      const status = Notification.permission;
      setPermissionStatus(status);
      
      // Montrer le banner seulement si les notifications ne sont pas encore accordées
      // et qu'on n'a pas déjà demandé (ou refusé)
      const hasAskedBefore = localStorage.getItem('notification-asked');
      setShowBanner(status === 'default' && !hasAskedBefore);
    }
  }, []);

  const handleRequestPermission = async () => {
    if ('Notification' in window) {
      const permission = await Notification.requestPermission();
      setPermissionStatus(permission);
      localStorage.setItem('notification-asked', 'true');
      setShowBanner(false);

      // Notification de test si accordée
      if (permission === 'granted') {
        new Notification('Notifications activées !', {
          body: 'Vous recevrez maintenant les notifications de nouveaux messages.',
          icon: '/favicon.ico'
        });
      }
    }
  };

  const handleDismiss = () => {
    setShowBanner(false);
    localStorage.setItem('notification-asked', 'true');
  };

  if (!showBanner) return null;

  return (
    <div className="notification-banner">
      <div className="banner-content">
        <div className="banner-icon">
          <Bell size={20} />
        </div>
        <div className="banner-text">
          <div className="banner-title">Activez les notifications</div>
          <div className="banner-subtitle">
            Recevez une notification quand vous recevez de nouveaux messages
          </div>
        </div>
        <div className="banner-actions">
          <button onClick={handleRequestPermission} className="btn-primary">
            Activer
          </button>
          <button onClick={handleDismiss} className="btn-dismiss">
            <X size={16} />
          </button>
        </div>
      </div>

    </div>
  );
};

export default NotificationBanner;